module.exports = __webpack_public_path__ + "static/media/Emblem_ai.6d7ad674.zip";